exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "img{max-width:100%}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-2a62b3e0","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Player.vue
// module id = 67
// module chunks = 0